// Date
import {parseISO, isDate} from 'date-fns';
import {formatToTimeZone} from 'date-fns-timezone';

const getLocalTimeZoneAbbreviation = (date) => {
  if (!date) return '';
  try {
    const dateObj = isDate(date) ? date : parseISO(date);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatToTimeZone(dateObj, 'z', {timeZone});
  } catch (error) {
    return '';
  }
};

export default getLocalTimeZoneAbbreviation;
